module.exports = __webpack_public_path__ + "static/media/2025Banner.08ad445a.jpg";